import { useContext, useMemo } from "react";
import { useParams } from "react-router-dom";

import { DatasetEditorContext } from "..";

import ArchiveButton from "./ArchiveButton";
import VersionHistoryMenu from "./VersionHistoryMenu";
import useDatasets from "./VersionHistoryMenu/hooks/useDatasets";

export const VersionSelector = ({
  handleDeleteDatasetGroup,
}: {
  handleDeleteDatasetGroup: () => void;
}) => {
  const { datasetId } = useParams();
  const context = useContext(DatasetEditorContext);

  const { currentVersion, sortedDatasets } = useDatasets(context?.datasets ?? [], datasetId);

  const isArchived = useMemo(() => !!context?.datasetGroup?.is_deleted, [context?.datasetGroup]);

  return (
    <>
      <VersionHistoryMenu
        currentVersion={currentVersion}
        sortedDatasets={sortedDatasets}
        datasets={context?.datasets ?? []}
        isDraft={context?.isDraft ?? false}
      />
      {!context?.isLoading && isArchived && !context?.isDraft && (
        <ArchiveButton onDelete={handleDeleteDatasetGroup} />
      )}
    </>
  );
};
